module.exports = __webpack_public_path__ + "img/driversLicenseExampleBack.a7f54c0a.svg";